import { api } from "../../api/apiSlice";

// Customer service emails and their replies (Batch184), keyed by the SOURCE record's
// guid - a Sales order, a Technical work item, or a client visit. One endpoint serves
// every job screen rather than one per module.
//
// Branch-scoped server-side. No dedicated permission: whoever can open the job can see
// whether the customer was told about it.
//
// NOTE: the customer's own page (/service-feedback/{token}) does NOT use this slice. It
// is anonymous and calls the public endpoints with a bare axios client, because this
// baseQuery attaches the stored JWT and redirects 401s to sign-in - which would bounce a
// customer to a login screen instead of letting them answer.
export const serviceFeedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerFeedback: builder.query({
      query: (sourceRecordGuid) => ({ url: `/customer-feedback/${sourceRecordGuid}` }),
      providesTags: (result, error, sourceRecordGuid) => [
        { type: "CustomerFeedback", id: sourceRecordGuid },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetCustomerFeedbackQuery } = serviceFeedbackApi;
